/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvoiceDocument } from '../../models/invoice-document';
import { SelectInvoiceDocumentServiceRequest } from '../../models/select-invoice-document-service-request';

export interface SelectInvoiceDocumentService$Params {
  uuid: string;
      body: SelectInvoiceDocumentServiceRequest
}

export function selectInvoiceDocumentService(http: HttpClient, rootUrl: string, params: SelectInvoiceDocumentService$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocument>> {
  const rb = new RequestBuilder(rootUrl, selectInvoiceDocumentService.PATH, 'patch');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InvoiceDocument>;
    })
  );
}

selectInvoiceDocumentService.PATH = '/invoice-document/{uuid}/service';
